<script lang="ts">
  import type { PageServerData } from "./$types";

  import AppDownload from "$lib/ui/home/seo/AppDownload.svelte";
  import SeoBusinessInfo from "$lib/ui/home/seo/SeoBusinessInfo.svelte";
  import SeoFooter from "$lib/ui/home/seo/SeoFooter.svelte";
  import SeoHeader from "$lib/ui/home/seo/SeoHeader.svelte";
  import SeoImageSlider from "$lib/ui/home/seo/SeoImageSlider.svelte";
  import Meta from "$lib/ui/shared/seo/Meta.svelte";
  import SeoBrandsGlossary from "$lib/ui/shared/seo/SeoBrandsGlossary.svelte";
  import SeoBusinessInfoItem from "$lib/ui/shared/seo/SeoBusinessInfoItem.svelte";
  import SeoExtraCopy from "$lib/ui/shared/seo/SeoExtraCopy.svelte";
  import SeoTagsLane from "$lib/ui/shared/seo/SeoTagsLane.svelte";
  import SeoTextBlock from "$lib/ui/shared/seo/SeoTextBlock.svelte";
  
  import { page } from "$app/stores";
  import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";
  
  export let data: PageServerData;

</script>

<svelte:head>
	<Meta meta={data.meta} />
	{#if data.canonical}
		<link rel="canonical" href={data.canonical} />
	{/if}
</svelte:head>

<SeoHeader image={data.headerImg} title='Best Restaurants near me' subtitle='Get food delivered to your door!' />

<SeoBrandsGlossary data={data.list} />

<SeoTextBlock title="Find the Best Restaurants Near You for Delivery">
  <p class="body-l">
    Looking for quick and easy access to delicious food from restaurants near you? MR D makes it simple to find local restaurants that deliver straight to your door. Whether you’re craving pizza, sushi, burgers, or gourmet meals, our platform connects you to a variety of cuisines available for delivery in your area.
  </p>
</SeoTextBlock>

<!-- Tags: Food -->
<SeoTagsLane title="Popular food types" list={data.cuisines} />

<SeoBusinessInfo>
	<SeoBusinessInfoItem item={data.biFeatures[0]} cta={{text: 'Order now', action: selectAddress}} />
	<SeoBusinessInfoItem item={data.biFeatures[1]} cta={{text: 'Order now', action: selectAddress}} />
	<SeoBusinessInfoItem item={data.biFeatures[2]} cta={{text: 'Order now', action: selectAddress}} />
</SeoBusinessInfo>

<!-- App download -->
{#if data.apps.main}
  <AppDownload main={data.apps.main} appstores={data.apps.stores} />
{/if}

<SeoBusinessInfo>
  <SeoBusinessInfoItem item={data.biCorpLinks[0]} cta={{text: 'Get started', action: '/about/become-a-restaurant-partner'}} />
  <SeoBusinessInfoItem item={data.biCorpLinks[1]} cta={{text: 'Apply now', action: '/about/become-a-driver'}} />
  <SeoBusinessInfoItem item={data.biCorpLinks[2]} cta={{text: 'Apply now', action: '/about/careers'}} />
</SeoBusinessInfo>

<!-- Image slider -->
<SeoImageSlider images={data.slides} />

<!-- Extra SEO Copy-->
<SeoExtraCopy seoExtras={data.extra} page={$page}/>

<!-- Extra SEO Copy-->
<SeoExtraCopy seoExtras={data.extra} page={$page}/>

<!-- Footer area -->
<SeoFooter appstores={data.apps.stores} socials={data.social} tallogo={data.tallogo}/>



